// extracted by mini-css-extract-plugin
export default {"info-icon-container":"info_info-icon-container__Kmdoy","info-icon":"info_info-icon__8+OmQ","info-popup":"info_info-popup__qOF4Y"};